import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'ant-design-vue/dist/antd.css';

AOS.init();

createApp(App).use(bootstrap).use(store).use(router).mount('#app')
